import Question from '@components/CMS/FAQ/Question'
import MainLayout from '@components/MainLayout/MainLayout'
import { PropTypes } from '@components/CMS/FAQ/types'

const FAQ: PropTypes = ({ data }) => {
  return (
    <MainLayout
      title="Frequently Asked Questions on BidFTA.com"
      previewDescription="Have questions on how online auctions work? Learn more about BidFTA, bidding platforms, and best practices with our FAQs."
    >
      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-6 py-24 sm:pt-32 lg:px-8 lg:py-40">
          <div className="mx-auto max-w-4xl divide-y divide-gray-900/10 prose">
            <h2 className="text-2xl font-bold leading-10 tracking-tight text-gray-900">
              Frequently Asked Questions
            </h2>
            <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
              {data.map(({ attributes }) => (
                <Question key={attributes.question} {...attributes} />
              ))}
            </dl>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default FAQ
